"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Emitter_1 = require("./Emitter");
const InstantTest_const_1 = require("./InstantTest.const");
const WsTriggerTesting_1 = tslib_1.__importDefault(require("./WsTriggerTesting"));
exports.default = {
    wsTt: null,
    isReady: false,
    actions: [],
    bytesSecInterval: null,
    triggerTestingUrl: '',
    init(triggerTestingUrl) {
        this.cancelEvents();
        this.triggerTestingUrl = triggerTestingUrl;
        Emitter_1.internalEmitter.on('ws:status', (message) => {
            this.handleStatus(message);
        });
        Emitter_1.internalEmitter.on('ws:test', (message) => {
            const modifiedMessage = this.handleUdpSpeedProperty(message);
            this.handleTest(modifiedMessage);
        });
    },
    connect(config) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                this.wsTt = new WsTriggerTesting_1.default(Object.assign({ url: this.triggerTestingUrl }, config));
                yield this.wsTt.connect();
            }
            catch (error) {
                if (error instanceof Error) {
                    Emitter_1.emitter.emit('error', error.message);
                }
                else {
                    console.error(error);
                }
            }
        });
    },
    cancelEvents() {
        Emitter_1.internalEmitter.off('ws:status');
        Emitter_1.internalEmitter.off('ws:test');
    },
    disconnect() {
        var _a;
        (_a = this.wsTt) === null || _a === void 0 ? void 0 : _a.disconnect();
        this.wsTt = null;
    },
    isConnected() {
        var _a;
        return (_a = this.wsTt) === null || _a === void 0 ? void 0 : _a.isAlive();
    },
    handleError(data) {
        var _a, _b, _c;
        this.disconnect();
        const { error } = data;
        if (!error) {
            return;
        }
        const errorCode = 
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any */ // Typescript will not allow us to cast correctly here, but we are safely checking for existence
        (_c = (_b = (_a = error.violations) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.code) !== null && _c !== void 0 ? _c : error.code;
        Emitter_1.emitter.emit('error', errorCode);
    },
    handleStatus({ data }) {
        var _a;
        // need to compare against boolean here to get the discriminated union
        if (data.success === false) {
            this.handleError(data);
            return;
        }
        const validActions = Object.values(InstantTest_const_1.UnitTestSchedulesTasks);
        const actions = ((_a = data.actions) !== null && _a !== void 0 ? _a : []).filter((action) => validActions.includes(action.task));
        this.actions = actions;
        this.isReady = data.ready;
        if (!actions || !actions.length) {
            this.handleError(Object.assign(Object.assign({}, data), { error: {
                    code: InstantTest_const_1.UnitErrors.NO_AVAILABLE_TESTS
                } }));
            return;
        }
        if (!this.isReady) {
            this.handleError(Object.assign(Object.assign({}, data), { error: {
                    code: InstantTest_const_1.UnitErrors.NOT_READY
                } }));
            return;
        }
        Emitter_1.internalEmitter.emit('instant-test:start-testing');
    },
    handleUdpSpeedProperty(testData) {
        const result = testData;
        if (result.data.status !== InstantTest_const_1.TestStatus.IN_PROGRESS &&
            result.data.status !== InstantTest_const_1.TestStatus.FINISHED) {
            return result;
        }
        if (result.data.task !== InstantTest_const_1.UnitTestSchedulesTasks.UDP_DOWNLOAD &&
            result.data.task !== InstantTest_const_1.UnitTestSchedulesTasks.UDP_UPLOAD) {
            return result;
        }
        result.data.data.bytes_sec = result.data.data.measured_speed;
        return result;
    },
    handleTest(message) {
        if (!message.success) {
            const { data } = message;
            const runningTest = {
                task: data.task,
                type: InstantTest_const_1.InstantTestType.UNIT_TEST,
                actionId: data.action_id
            };
            Emitter_1.internalEmitter.emit('instant-test:cancel');
            Emitter_1.internalEmitter.emit('instant-test:results', {
                runningTest,
                result: data /* eslint-disable-line @typescript-eslint/no-explicit-any */,
                status: data.status /* eslint-disable-line @typescript-eslint/no-explicit-any */ // Casting to `any` because it's unclear what is supposed to happen here but this is existing behaviour
            });
            Emitter_1.internalEmitter.emit('instant-test:ingest');
            this.handleError(data);
            return;
        }
        if (message.data.status === InstantTest_const_1.TestStatus.IN_PROGRESS ||
            message.data.status === InstantTest_const_1.TestStatus.FINISHED) {
            const status = message.data.status;
            const { data } = message;
            const runningTest = {
                task: data.task,
                type: InstantTest_const_1.InstantTestType.UNIT_TEST,
                actionId: data.action_id
            };
            Emitter_1.internalEmitter.emit('instant-test:results', {
                runningTest,
                result: data,
                status
            });
        }
        if (message.data.status === InstantTest_const_1.TestStatus.FINISHED) {
            Emitter_1.internalEmitter.emit('instant-test:test-finished');
        }
    },
    runningTest(test) {
        this.wsTt.sendMessage('test', {
            action_id: test.actionId
        });
    }
};
//# sourceMappingURL=UnitTriggerTesting.js.map